import { ServiceUtils } from "@36kr/redux-service";
import arrayMove from 'array-move';
import { message } from "antd";

/**
 * 映射对象的key
 * 把指定key更换为接口要求的名字
 * @param {Object} obj
 * @param {[key: string] : string} keyPairs
 */
const normalizeKeyForServer = (obj, keyPairs) => {
  return Object.keys(obj).reduce((result, key) => {
    let newKey = key
    if (keyPairs[key]) {
      newKey = keyPairs[key]
    }
    result[newKey] = obj[key]
    return result
  }, {})
}
/**
 * @typedef {{ossUrl: string, path: string}} AliImage 
 */
/**
 * // TODO 2020-03-04 19:43:46， 现在看个人认为AtlatItem有点设计过度，后续可以改成直接对接接口，后来维护此项目的同学也可以修复下 // FIXME
 * @typedef {Object} ImagePaths
 */
class AtlasItem {
  constructor (file, profile, imagePaths = {}) {
    this.file = file
    this.profile = profile
    /**
     * @type {ImagePaths}
     */
    this.imagePaths = imagePaths
    // 接口和本地字段名不一致
    // 此对象是用来存储映射规则的
    // key => 对象自己的key
    // value => 接口的key
    this.normalizeRule = {}
  }
  
  getParam () {
    return {
      bigImagePath: this.imagePaths.path,
      ...this.profile,
    }
  }
  getParamForServer () {
    return normalizeKeyForServer(this.getParam(), this.normalizeRule)
  }
}

const getFileName = file => {
  return (file && file.name) ? file.name.replace(/\.\w+$/, '') : undefined
}

class AtlasPhotoItem extends AtlasItem {
  constructor (file, imagePaths, profile = {}) {
    super(file, {remark : getFileName(file), ...profile}, imagePaths)
  }
}

const atlasItemFactory = (key, fileList, imagePaths) => {
  const list = []
  for (let i = 0; i < fileList.length; i++) {
    const file = fileList[i]
    list.push(new AtlasPhotoItem(file, imagePaths[i]))
  }
  return list
}

export default {
  editAtlas: ServiceUtils.createReducer({
    allFields: {},
    id: null,
    mode: 'edit', // edit or sort,
    atlasTitle: {
      person: undefined,
      logo: undefined,
      other: undefined,
    },
    atlas: {
      person: [],
      logo: [],
      other: [],
    },
  }, {
    'INIT_TYPE': (state, {payload}) => {
      return {
        ...state,
        id: payload.id ? Number(payload.id) : null,
      }
    },
    'INIT_ATLAS': (state, {payload}) => {
      const { key, data} = payload;

      return {
        ...state,
        atlasTitle: {
          ...state.atlasTitle,
          [key]: data.title,
        },
        atlas: {
          ...state.atlas,
          [key]: data.photoList.map(item => {
            const result = {
              imagePaths: {
                ...item,
                ossUrl: item.imageOssUrl,
                path: item.imagePath,
              },
            }
            Object.assign(result, {
              profile: {
                itemId: item.itemId,
                desc: item.desc,
              }
            })
            return new AtlasPhotoItem(null, result.imagePaths, result.profile)
          })
        }
      }
    },
    'ADD_ATLAS_ITEM': (state, {payload}) => {
      const { key, fileList, imagePaths } = payload
      return {
        ...state,
        atlas: {
          ...state.atlas,
          [key]: state.atlas[key].concat(atlasItemFactory(key, fileList, imagePaths)),
        }
      }
    },
    'REMOVE_ATLAS_ITEM': (state, {payload}) => {
      const { idx, key } = payload

      return {
        ...state,
        atlas: {
          ...state.atlas,
          [key]: state.atlas[key].filter((_, i) => i !== idx)
        }
      }
    },
    'CHANGE_MODE': (state, {payload}) => {
      return {
        ...state,
        mode: payload.value
      }
    },
    'SORT_ATLAS': (state, {payload}) => {
      const {key, from, to} = payload
      return {
        ...state,
        atlas: {
          ...state.atlas,
          [key]: arrayMove(state.atlas[key], from ,to)
        }
      }
    },
  })
}
